import { HTMLAttributes, FC, useState } from "react";
import { isIOS, isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { StaticImage } from "../StaticImage";
import { System } from "../../../models/systems";
import { Typography } from "../../core/Typography/Typography";
import { TypographyVariant } from "../../../constants/typography";
import { Icon } from "../../core/Icon/Icon";
import { useAppDispatch } from "../../hooks";
import { addPopupQueue } from "../../../store/slices/popup";
import { PopupType } from "../../../constants/popup";
import { cache } from "../../../models/pwa";
import { assetsImages } from "../../../models/theme";

export const PwaDownload: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [isInstall, setIsInstall] = useState(System.isPwaInstalled());

  const onGetApp = async () => {
    if (isIOS) {
      dispatch(addPopupQueue({ type: PopupType.IOSInstall }));
    } else {
      if (cache[`${window.location.protocol}//${window.location.host}/`]) {
        await cache[
          `${window.location.protocol}//${window.location.host}/`
        ].prompt();
        cache[
          `${window.location.protocol}//${window.location.host}/`
        ].userChoice.then(
          (choiceResult: { outcome: "accepted" | "dismissed" }) => {
            if (choiceResult.outcome === "accepted") {
              setIsInstall(true);
              localStorage.setItem("hidePWABanner", "true");
            }
          },
        );
      }
    }
  };

  if (isInstall || !isMobile) return null;

  return (
    <div className={props.className} onClick={onGetApp}>
      <StaticImage src={assetsImages?.loadingLogo?.["2x"]} height={40} />
      <div>
        <Typography variant={TypographyVariant.BodyB6Regular}>
          {t("PwaBanner_Download app for a better game experience", {
            appName: "The Gaming Platform",
          })}
        </Typography>
      </div>
      <Icon name="icon-linear-download" size={24} />
    </div>
  );
};
